export const DocksResource = {
  name: "Docks",
  path: "/fleets/settings/docks",
  access: ["read-docks"],
};
